import { render, staticRenderFns } from "./NsTopnavProductHighlight.vue?vue&type=template&id=c40618e4&scoped=true&"
import script from "./NsTopnavProductHighlight.vue?vue&type=script&lang=js&"
export * from "./NsTopnavProductHighlight.vue?vue&type=script&lang=js&"
import style0 from "./NsTopnavProductHighlight.vue?vue&type=style&index=0&id=c40618e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40618e4",
  null
  
)

export default component.exports